import React from 'react';

const AdminFormSection = ({ title, hint, children, className = '' }) => (
  <section className={`admin-form-section ${className}`.trim()}>
    <div className="admin-form-section-head">
      <h3>{title}</h3>
      {hint ? <p>{hint}</p> : null}
    </div>
    <div className="admin-form-section-body">{children}</div>
  </section>
);

export default AdminFormSection;
